import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { StyledSocialIcons } from "./styled/SocialIcons.styled";

const SocialIcons = () => {
  return (
    <StyledSocialIcons>
      <li>
        <a
          target="_blank"
          href="https://instagram.com/sardanaindahberlianmotor"
        >
          <FaInstagram />
        </a>
        <a target="_blank" href="https://facebook.com/sardanaindahberlianmotor">
          <FaFacebook />
        </a>
        <a
          target="_blank"
          href="https://wa.me/+628116541800?text=[NXP] Halo Sardana Berlian."
        >
          <FaWhatsapp />
        </a>
      </li>
    </StyledSocialIcons>
  );
};

export default SocialIcons;
